import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { Button } from '../button';
import { CalendarIcon } from 'lucide-react';
import { MonthCalProps, MonthPicker } from './month-picker';
import dayjs from 'dayjs';

type Props = {
  value: Date;
  onChange: (date: Date) => void;
  customLabelValue?: string;
  slots?: {
    monthPicker?: React.HTMLAttributes<HTMLDivElement> & MonthCalProps;
  };
} & Omit<React.ComponentProps<typeof Button>, 'value' | 'onChange'>;
const ButtonMonthPicker = ({
  value,
  onChange,
  className,
  customLabelValue,
  slots,
  ...props
}: Props) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={'outline'}
          className={cn(
            'justify-start font-normal',
            !value && 'text-muted-foreground',
            className
          )}
          startIcon={<CalendarIcon className="h-4 w-4" />}
          {...props}
        >
          {value ? (
            customLabelValue || dayjs(value).format('MMM YYYY')
          ) : (
            <span>Pick a month</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <MonthPicker
          onMonthSelect={onChange}
          selectedMonth={value}
          {...slots?.monthPicker}
        />
      </PopoverContent>
    </Popover>
  );
};

export default ButtonMonthPicker;
